import { useCallback } from 'react';

import { useResource } from 'react-resource-router';

import { loadAgenticPipelinesConfiguration } from 'src/components/pipelines/resources/agentic-pipelines-configuration';
import { authRequest, jsonHeaders } from 'src/utils/fetch';

import envBaseUrl from '../utils/env-base-url';

export const useAgenticPipelinesConfiguration = (workspaceSlug: string) => {
  const { data: config } = useResource(loadAgenticPipelinesConfiguration);
  const agenticPipelinesEnabled = config?.enabled;
  const providersEnabled = config?.providers;
  const baseUrl = envBaseUrl('/!api/internal');

  const updateAgenticPipelinesConfiguration = useCallback(
    async (enabled: boolean) => {
      const response = await fetch(
        authRequest(
          `${baseUrl}/workspaces/${workspaceSlug}/pipelines-config/agentic-pipelines-configuration`,
          {
            method: 'PUT',
            headers: jsonHeaders,
            body: JSON.stringify({ enabled }),
          }
        )
      );

      return response;
    },
    [baseUrl, workspaceSlug]
  );

  const updateProviderEnabled = useCallback(
    async (provider: string, enabled: boolean) => {
      const currentProviders = config?.providers ?? {};

      const response = await fetch(
        authRequest(
          `${baseUrl}/workspaces/${workspaceSlug}/pipelines-config/agentic-pipelines-configuration`,
          {
            method: 'PUT',
            headers: jsonHeaders,
            body: JSON.stringify({
              enabled: agenticPipelinesEnabled ?? true,
              providers: { ...currentProviders, [provider]: enabled },
            }),
          }
        )
      );

      return response;
    },
    [config?.providers, baseUrl, workspaceSlug, agenticPipelinesEnabled]
  );

  return {
    agenticPipelinesEnabled,
    providersEnabled,
    updateAgenticPipelinesConfiguration,
    updateProviderEnabled,
  };
};
